import { FILTER_OPTIONS } from "@constants/dashboard";
import { OrganisationDataProps } from "@models/components/organisation.model";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  city: string;
  club: string;
  country: string;
  filteredOrganisationData: OrganisationDataProps[];
  isCity: boolean;
  isSearch: boolean;
  filterValue: FILTER_OPTIONS | null;
  openToPublicFilter: boolean;
  nearMeFilter: boolean;
};

const initialState: initialType = {
  city: "",
  club: "",
  country: "",
  filteredOrganisationData: [],
  filterValue: null,
  isCity: true,
  isSearch: false,
  nearMeFilter: false,
  openToPublicFilter: false,
};

type dashboardSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setLocation: dashboardSliceReducer<{
  city: string;
  club: string;
  country: string;
  isCity: boolean;
  isSearch: boolean;
}> = (state, action) => {
  state.city = action.payload.city;
  state.country = action.payload.country;
  state.club = action.payload.club;
  state.isSearch = action.payload.isSearch;
  state.isCity = action.payload.isCity;
};

const setFilteredOrganisationData: dashboardSliceReducer<{
  filteredOrganisationData: OrganisationDataProps[];
}> = (state, action) => {
  state.filteredOrganisationData = action.payload.filteredOrganisationData;
};

const setFilterValue: dashboardSliceReducer<{
  filterValue: FILTER_OPTIONS;
}> = (state, action) => {
  state.filterValue = action.payload.filterValue;
};

const setOpenToPublicFilter: dashboardSliceReducer<{
  openToPublicFilter: boolean;
}> = (state, action) => {
  state.openToPublicFilter = action.payload.openToPublicFilter;
};

const setNearMeFilter: dashboardSliceReducer<{
  nearMeFilter: boolean;
}> = (state, action) => {
  state.nearMeFilter = action.payload.nearMeFilter;
};

const resetDashboard: dashboardSliceReducer<null> = state => {
  state.city = "";
  state.club = "";
  state.country = "";
  state.filteredOrganisationData = [];
  state.isCity = true;
  state.isSearch = false;
  state.filterValue = null;
  state.openToPublicFilter = false;
  state.nearMeFilter = false;
};

export const dashboardSlice = createSlice({
  initialState,
  name: "dashboard",
  reducers: {
    resetDashboard,
    setFilteredOrganisationData,
    setFilterValue,
    setLocation,
    setNearMeFilter,
    setOpenToPublicFilter,
  },
});

export default dashboardSlice;
